import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './there-is-there-are-explanation';

const sections = [
  { label: 'Grammar', description: 'Do this exercise to practice grammar.', type: 'quiz', subtype: 'thereisthereare' },
];

const ThereIsThereAre = () => (
  <GrammarPageLayout
    level='A1'
    title='There is / There are'
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle='Free English Exercises: There is / There are'
    seoDescription='Practice There is / There are with interactive exercises for A1 level English.'
    relatedCategory='grammar-exercises'
    relatedLevel='A1'
  />
);

export default ThereIsThereAre;
